/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDiscreteNumericListDtoGeometry } from './CreateDiscreteNumericListDtoGeometry';
import {
    CreateDiscreteNumericListDtoGeometryFromJSON,
    CreateDiscreteNumericListDtoGeometryFromJSONTyped,
    CreateDiscreteNumericListDtoGeometryToJSON,
} from './CreateDiscreteNumericListDtoGeometry';
import type { CreateNumericEvaluationParameterDtoEvaluationType } from './CreateNumericEvaluationParameterDtoEvaluationType';
import {
    CreateNumericEvaluationParameterDtoEvaluationTypeFromJSON,
    CreateNumericEvaluationParameterDtoEvaluationTypeFromJSONTyped,
    CreateNumericEvaluationParameterDtoEvaluationTypeToJSON,
} from './CreateNumericEvaluationParameterDtoEvaluationType';
import type { CreateNumericEvaluationParameterDtoLimitType } from './CreateNumericEvaluationParameterDtoLimitType';
import {
    CreateNumericEvaluationParameterDtoLimitTypeFromJSON,
    CreateNumericEvaluationParameterDtoLimitTypeFromJSONTyped,
    CreateNumericEvaluationParameterDtoLimitTypeToJSON,
} from './CreateNumericEvaluationParameterDtoLimitType';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { NumericEvaluationParameterDtoDefinition } from './NumericEvaluationParameterDtoDefinition';
import {
    NumericEvaluationParameterDtoDefinitionFromJSON,
    NumericEvaluationParameterDtoDefinitionFromJSONTyped,
    NumericEvaluationParameterDtoDefinitionToJSON,
} from './NumericEvaluationParameterDtoDefinition';
import type { NumericEvaluationParameterDtoDefinitionParameterValueSet } from './NumericEvaluationParameterDtoDefinitionParameterValueSet';
import {
    NumericEvaluationParameterDtoDefinitionParameterValueSetFromJSON,
    NumericEvaluationParameterDtoDefinitionParameterValueSetFromJSONTyped,
    NumericEvaluationParameterDtoDefinitionParameterValueSetToJSON,
} from './NumericEvaluationParameterDtoDefinitionParameterValueSet';

/**
 * 
 * @export
 * @interface NumericEvaluationParameterDto
 */
export interface NumericEvaluationParameterDto {
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationParameterDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationParameterDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationParameterDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NumericEvaluationParameterDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationParameterDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NumericEvaluationParameterDto
     */
    allowRepetition?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof NumericEvaluationParameterDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationParameterDto
     */
    instruction?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NumericEvaluationParameterDto
     */
    upperWarningLimit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NumericEvaluationParameterDto
     */
    upperFailedLimit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NumericEvaluationParameterDto
     */
    lowerFailedLimit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NumericEvaluationParameterDto
     */
    lowerWarningLimit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NumericEvaluationParameterDto
     */
    decimalPlaces?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NumericEvaluationParameterDto
     */
    min?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NumericEvaluationParameterDto
     */
    max?: number | null;
    /**
     * 
     * @type {NumericEvaluationParameterDtoDefinition}
     * @memberof NumericEvaluationParameterDto
     */
    definition: NumericEvaluationParameterDtoDefinition | null;
    /**
     * 
     * @type {CreateNumericEvaluationParameterDtoEvaluationType}
     * @memberof NumericEvaluationParameterDto
     */
    evaluationType?: CreateNumericEvaluationParameterDtoEvaluationType | null;
    /**
     * 
     * @type {CreateNumericEvaluationParameterDtoLimitType}
     * @memberof NumericEvaluationParameterDto
     */
    limitType?: CreateNumericEvaluationParameterDtoLimitType | null;
    /**
     * 
     * @type {NumericEvaluationParameterDtoDefinitionParameterValueSet}
     * @memberof NumericEvaluationParameterDto
     */
    definitionParameterValueSet?: NumericEvaluationParameterDtoDefinitionParameterValueSet | null;
    /**
     * 
     * @type {CreateDiscreteNumericListDtoGeometry}
     * @memberof NumericEvaluationParameterDto
     */
    geometry?: CreateDiscreteNumericListDtoGeometry | null;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationParameterDto
     */
    readonly evaluationUnitAbbreviation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationParameterDto
     */
    readonly limitUnitAbbreviation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationParameterDto
     */
    $type?: NumericEvaluationParameterDtoTypeEnum;
}


/**
 * @export
 */
export const NumericEvaluationParameterDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoEvaluationParametersNumericEvaluationParameterDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.NumericEvaluationParameterDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type NumericEvaluationParameterDtoTypeEnum = typeof NumericEvaluationParameterDtoTypeEnum[keyof typeof NumericEvaluationParameterDtoTypeEnum];


/**
 * Check if a given object implements the NumericEvaluationParameterDto interface.
 */
export function instanceOfNumericEvaluationParameterDto(value?: unknown): value is NumericEvaluationParameterDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(NumericEvaluationParameterDtoTypeEnum)[0];
}

export function NumericEvaluationParameterDtoFromJSON(json: any): NumericEvaluationParameterDto {
    return NumericEvaluationParameterDtoFromJSONTyped(json, false);
}

export function NumericEvaluationParameterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumericEvaluationParameterDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'dataTypeId': !exists(json, 'dataTypeId') ? undefined : json['dataTypeId'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'allowRepetition': !exists(json, 'allowRepetition') ? undefined : json['allowRepetition'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'instruction': !exists(json, 'instruction') ? undefined : json['instruction'],
        'upperWarningLimit': !exists(json, 'upperWarningLimit') ? undefined : json['upperWarningLimit'],
        'upperFailedLimit': !exists(json, 'upperFailedLimit') ? undefined : json['upperFailedLimit'],
        'lowerFailedLimit': !exists(json, 'lowerFailedLimit') ? undefined : json['lowerFailedLimit'],
        'lowerWarningLimit': !exists(json, 'lowerWarningLimit') ? undefined : json['lowerWarningLimit'],
        'decimalPlaces': !exists(json, 'decimalPlaces') ? undefined : json['decimalPlaces'],
        'min': !exists(json, 'min') ? undefined : json['min'],
        'max': !exists(json, 'max') ? undefined : json['max'],
        'definition': NumericEvaluationParameterDtoDefinitionFromJSON(json['definition']),
        'evaluationType': !exists(json, 'evaluationType') ? undefined : CreateNumericEvaluationParameterDtoEvaluationTypeFromJSON(json['evaluationType']),
        'limitType': !exists(json, 'limitType') ? undefined : CreateNumericEvaluationParameterDtoLimitTypeFromJSON(json['limitType']),
        'definitionParameterValueSet': !exists(json, 'definitionParameterValueSet') ? undefined : NumericEvaluationParameterDtoDefinitionParameterValueSetFromJSON(json['definitionParameterValueSet']),
        'geometry': !exists(json, 'geometry') ? undefined : CreateDiscreteNumericListDtoGeometryFromJSON(json['geometry']),
        'evaluationUnitAbbreviation': !exists(json, 'evaluationUnitAbbreviation') ? undefined : json['evaluationUnitAbbreviation'],
        'limitUnitAbbreviation': !exists(json, 'limitUnitAbbreviation') ? undefined : json['limitUnitAbbreviation'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function NumericEvaluationParameterDtoToJSON(value?: NumericEvaluationParameterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'name': value.name,
        'dataTypeId': value.dataTypeId,
        'isEnabled': value.isEnabled,
        'iuid': value.iuid,
        'allowRepetition': value.allowRepetition,
        'origin': EntityOriginToJSON(value.origin),
        'instruction': value.instruction,
        'upperWarningLimit': value.upperWarningLimit,
        'upperFailedLimit': value.upperFailedLimit,
        'lowerFailedLimit': value.lowerFailedLimit,
        'lowerWarningLimit': value.lowerWarningLimit,
        'decimalPlaces': value.decimalPlaces,
        'min': value.min,
        'max': value.max,
        'definition': NumericEvaluationParameterDtoDefinitionToJSON(value.definition),
        'evaluationType': CreateNumericEvaluationParameterDtoEvaluationTypeToJSON(value.evaluationType),
        'limitType': CreateNumericEvaluationParameterDtoLimitTypeToJSON(value.limitType),
        'definitionParameterValueSet': NumericEvaluationParameterDtoDefinitionParameterValueSetToJSON(value.definitionParameterValueSet),
        'geometry': CreateDiscreteNumericListDtoGeometryToJSON(value.geometry),
        '$type': value.$type,
    });
}

